import React from 'react';
import WorkspacePlaceholder from '../../MiscPages/WorkspacePlaceholder.page';

/**
 * Solutions > LearnCreator > Preview.
 *
 * Unlinked from the old LearnCreator entry page — a new UI for this preview
 * is planned, so this no longer hands off to the existing flow in the
 * meantime (same "not built yet" treatment as any other pending nav
 * destination, see WorkspacePlaceholder.page.jsx).
 */
const SolutionLearnCreatorPreviewPage = () => <WorkspacePlaceholder title="Preview" />;

export default SolutionLearnCreatorPreviewPage;
